export enum ContentScheduleDateType {
  VIRTUAL_GROUP_AND_CONTENT = 1,
  VIRTUAL_GROUP_AND_COURSE_TEST = 2,
  VIRTUAL_GROUP_AND_CLOSURE_TASK = 3,
  VIRTUAL_GROUP_AND_RELEASE_TEST_GRADE = 4,
}